/**
 * id: must be unique
 * text: display text
 * component: component attached
 */
import Intermediary from './Intermediary'
import PolType from './PolType'

export default [
  {
    id: 'intermediary',
    text: 'Intermediary',
    component: Intermediary
  },
  {
    id: 'polType',
    text: 'Policy Type',
    component: PolType
  }
]
